import { useQuery } from '@tanstack/react-query'
import { createApiCall } from 'services'
import { Country } from 'types'

interface CountriesResponse {
  data: Country[]
}

interface UseCountriesResult {
  data: Country[] | undefined
  isLoading: boolean
  isError: boolean
  error: Error | null
  refetch: () => void
}

export const useCountriesQuery = (enabled = true): UseCountriesResult => {
  const query = useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      const response = await createApiCall({
        method: 'GET',
        url: '/common/countries',
      })
      return response.data as CountriesResponse
    },
    staleTime: 1000 * 60 * 60 * 24, // Countries don't change often, cache for 24 hours
    // `/common/countries` sits behind `AuthGuard` (apps/api's CommonController) —
    // an unauthenticated caller (e.g. the public self-serve signup page) must
    // never fire this query, or it 401s. Callers in a public context pass
    // `enabled: false` and supply their own static list instead (see
    // SelectCountryField's `countriesOverride`).
    enabled,
  })

  return {
    data: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}
